import { Modal } from 'components/notifications'
import { forwardRef, useImperativeHandle, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CreatedApiKeyModalContent } from './CreatedApiKeyModalContent'

interface Props {
  token?: string
}

export interface ApiKeyImperativeHandle {
  open: () => void
}

export const ApiKeyModal = forwardRef<ApiKeyImperativeHandle, Props>(
  ({ token }, ref) => {
    const { t } = useTranslation()
    const [hidden, setHidden] = useState(true)
    const [highlightConfirmation, setHighlightConfirmation] = useState(false)
    const [confirmedCopy, setConfirmedCopy] = useState(false)

    const reset = () => {
      setConfirmedCopy(false)
      setHighlightConfirmation(false)
    }

    const close = () => {
      reset()
      setHidden(true)
    }

    useImperativeHandle(ref, () => ({
      open: () => {
        reset()
        setHidden(false)
      },
    }))

    return (
      <Modal
        variant="form"
        hidden={hidden}
        title={t('features.settings.createApiKey')}
        content={(handleClose) => (
          <CreatedApiKeyModalContent
            confirmedCopy={confirmedCopy}
            highlightConfirmation={highlightConfirmation}
            onConfirmCopy={(confirmed) => {
              setConfirmedCopy(confirmed)
            }}
            token={token}
            onClose={handleClose}
          />
        )}
        onClose={() => {
          if (!token) return close()
          if (confirmedCopy) return close()

          setHighlightConfirmation(true)
        }}
      />
    )
  },
)

ApiKeyModal.displayName = 'ApiKeyModal'
